import { useMemo } from "react";

import ShiftTypeFilterDropdown from "../../ShiftTypeFilterDropdown";
import { TShiftEditorProps } from "../types";

export const ShiftEditorShiftTypePicker = (props: TShiftEditorProps) => {
  const { staffShift, updateStaffShift, readonly, availableShiftTypes } = props;

  // shift type selector
  const shiftType = useMemo(
    () =>
      staffShift.shiftTypeKey &&
      availableShiftTypes?.find(({ key }) => key === staffShift.shiftTypeKey),
    [availableShiftTypes, staffShift.shiftTypeKey],
  );

  return (
    <ShiftTypeFilterDropdown
      size="small"
      className="shift-type-dropdown"
      hoursInLabel={"skipInput"}
      shiftTypes={availableShiftTypes || []}
      selectedOption={shiftType}
      selectOption={(staffShiftType) =>
        staffShiftType?.key &&
        updateStaffShift({
          ...staffShift,
          shiftTypeKey: staffShiftType.key,
          customDuration: null,
          customStartTime: null,
        })
      }
      isMultiSelect={false}
      readonly={readonly}
      label={"Shift Type"}
      sx={{
        minHeight: "47px",
      }}
    />
  );
};
